import { getCategoriaLabel } from './iniciativa-categoria';

const ETAPA1_TO_CATEGORY: Record<string, string[]> = {
  CONEXAO: ['CONEXAO'],
  SIMPLIFIQUE: ['SIMPLIFIQUE'],
  JJ_PREDEFINIDO: ['PILAR'],
};

const ECBB_PREFIX = 'ECBB_';
const JJ_HIBRIDO = 'JJ_HIBRIDO';
const MAD_KEY = 'MAD';
const ECBB_REDE_KEY = 'ECBB_REDE';

const ETAPA1_LABELS: Record<string, string> = {
  CONEXAO: 'Negócios e Atendimento',
  SIMPLIFIQUE: 'Simplificação e Eficiência',
  JJ_PREDEFINIDO: 'Pilar de Sustentação',
  JJ_HIBRIDO: 'ECBB',
  MAD: 'ECBB - MAD',
  ECBB_REDE: 'ECBB - Rede',
};

export interface CategoriaVotacao {
  etapa1Key: string;
  categoryPremioFilter: string[];
  label: string;
  isEcbb: boolean;
  isMad: boolean;
  isRede: boolean;
}

export const getEtapa1Label = (etapa1Key: string): string => {
  return ETAPA1_LABELS[etapa1Key] || etapa1Key;
};

export const getCategoriasVotacao = (
  etapa1: string[],
  todasIniciativas: { categoryPremio: string; isMad?: boolean; isRede?: boolean }[]
): CategoriaVotacao[] => {
  return etapa1.flatMap((key) => {
    const upper = key.toUpperCase();

    if (upper === JJ_HIBRIDO) {
      const ecbbIniciativas = todasIniciativas.filter(
        (i) => i.categoryPremio.startsWith(ECBB_PREFIX) && i.isMad !== true
      );
      const temSemRede = ecbbIniciativas.some((i) => i.isRede !== true);
      const temComRede = ecbbIniciativas.some((i) => i.isRede === true);

      const ecbbCategoriesSemRede = Array.from(
        new Set(
          ecbbIniciativas
            .filter((i) => i.isRede !== true)
            .map((i) => i.categoryPremio)
        )
      );
      const ecbbCategoriesComRede = Array.from(
        new Set(
          ecbbIniciativas
            .filter((i) => i.isRede === true)
            .map((i) => i.categoryPremio)
        )
      );

      const buckets: CategoriaVotacao[] = [];

      if (temSemRede || !temComRede) {
        buckets.push({
          etapa1Key: key,
          categoryPremioFilter: ecbbCategoriesSemRede,
          label: ETAPA1_LABELS[upper] || 'ECBB',
          isEcbb: true,
          isMad: false,
          isRede: false,
        });
      }

      if (temComRede) {
        buckets.push({
          etapa1Key: ECBB_REDE_KEY,
          categoryPremioFilter: ecbbCategoriesComRede,
          label: ETAPA1_LABELS[ECBB_REDE_KEY],
          isEcbb: true,
          isMad: false,
          isRede: true,
        });
      }

      return buckets;
    }

    if (upper === MAD_KEY) {
      return [{
        etapa1Key: key,
        categoryPremioFilter: [],
        label: ETAPA1_LABELS[upper] || 'ECBB - MAD',
        isEcbb: false,
        isMad: true,
        isRede: false,
      }];
    }

    const mapped = ETAPA1_TO_CATEGORY[upper] || [upper];
    const label = ETAPA1_LABELS[upper] || mapped.map(getCategoriaLabel).join(', ') || upper;

    return [{
      etapa1Key: key,
      categoryPremioFilter: mapped,
      label,
      isEcbb: false,
      isMad: false,
      isRede: false,
    }];
  });
};

export const filterIniciativasByCategoria = <T extends { categoryPremio: string; isMad?: boolean; isRede?: boolean }>(
  iniciativas: T[],
  categoria: CategoriaVotacao
): T[] => {
  if (categoria.isMad) {
    return iniciativas.filter((i) => i.isMad === true);
  }
  if (categoria.isEcbb && categoria.isRede) {
    return iniciativas.filter(
      (i) => i.categoryPremio.startsWith(ECBB_PREFIX) && i.isRede === true && i.isMad !== true
    );
  }
  if (categoria.isEcbb) {
    return iniciativas.filter(
      (i) => i.categoryPremio.startsWith(ECBB_PREFIX) && i.isRede !== true && i.isMad !== true
    );
  }
  return iniciativas.filter(
    (i) => categoria.categoryPremioFilter.includes(i.categoryPremio) && i.isMad !== true && i.isRede !== true
  );
};
